import React, { useState, useCallback } from "react";
import Collapse from "react-bootstrap/Collapse";

const redStrikethrough = {
  textDecoration: "line-through",
  textDecorationColor: "red",
  textDecorationThickness: "1px",
};

const noPointerStyle = {
  pointerEvents: "none",
  cursor: "default",
};

const BillDetails = ({ billdata }) => {
  const [collapseShow, setCollapseShow] = useState(false);

  const formatAmount = useCallback((num) => {
    if (num === undefined || num === null) return "0.00";
    const numValue = typeof num === "string" ? parseFloat(num) : num;
    return numValue.toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }, []);

  if (!billdata) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const formatTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}`;
  };

  const formattedDate =
    billdata.order && billdata.order.created_at
      ? formatDate(billdata.order.created_at)
      : "-";

  const formattedOpenTime =
    billdata.order && billdata.order.created_at
      ? formatTime(billdata.order.created_at)
      : "-";

  const formattedPaymentTime =
    billdata.payment &&
    billdata.payment.length > 0 &&
    billdata.payment[0].created_at
      ? formatTime(billdata.payment[0].created_at)
      : "-";

  const getDisplayNumber = () => {
    if (billdata.billStatus === 5 && billdata.refund_no) {
      return billdata.refund_no;
    } else {
      return billdata.orderNo;
    }
  };

  const getNumberLabel = () => {
    if (billdata.billStatus === 5) {
      return "Refund No.";
    } else {
      return "Order No.";
    }
  };

  const isVoided =
    billdata?.billStatus === 6 ||
    billdata?.status === "VOIDED" ||
    Boolean(billdata?.voided_at);

  return (
    <div
      className="p-3 position-relative"
      style={{
        height: "calc(100vh - 150px)",
        borderRadius: "8px",
        background: "#FFF",
        boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.14)",
      }}
    >
      <div className="d-flex align-items-center">
        <div className="me-auto">
          <span className="text-14 text-[#2DC76D] me-2">
            {getNumberLabel()}
          </span>
          <span className="text-14 text-[#2F4858]">{getDisplayNumber()}</span>
        </div>
        {billdata.billStatus === 1 && (
          <div className="bill-status-s2">เปิดบิลอยู่</div>
        )}
        {billdata.billStatus === 2 && (
          <div className="bill-status-s1">พักบิล</div>
        )}
        {billdata.billStatus === 3 && (
          <div className="bill-status-s3">สำเร็จ</div>
        )}
        {billdata.billStatus === 4 && (
          <div className="bill-status-s4">ยกเลิก</div>
        )}
        {billdata.billStatus === 5 && (
          <div className="bill-status-s4">คืนสินค้า</div>
        )}
        {isVoided && (
          <div
            style={{
              display: "inline-block",
              backgroundColor: "transparent",
              border: "2px solid #FF0000",
              borderRadius: "12px",
              color: "#FF0000",
              padding: "2px 10px",
              fontSize: "10px",
              fontWeight: 600,
              textAlign: "center",
              minWidth: 40,
              marginLeft: 8,
            }}
          >
            VOID
          </div>
        )}
      </div>
      <div>
        <span className="text-14 text-[#2DC76D] me-2">Receipt No.</span>
        <span className="text-[#2F4858] text-14">
          {billdata.receiptNo || "-"}
        </span>
      </div>
      <div>
        <span className="text-12 text-[#2DC76D] me-2">พนักงาน :</span>
        <span className="text-12 text-[#2F4858]">{billdata.staff || "-"}</span>
      </div>
      <div>
        <span className="text-12 text-[#2DC76D] me-2">วันที่ :</span>
        <span className="text-12 text-[#2F4858] me-2">{formattedDate}</span>
        <span className="text-12 text-[#2DC76D] me-2">จุดขาย :</span>
        <span className="text-12 text-[#2F4858]">{billdata.pos || "-"}</span>
      </div>
      <div className="row g-0">
        <div className="col">
          <div>
            <span className="text-12 text-[#2DC76D] me-2">เวลาเปิดบิล :</span>
            <span className="text-12 text-[#2F4858] me-2">
              {formattedOpenTime}
            </span>
            <span className="text-12 text-[#2DC76D] me-2">เวลาชำระเงิน :</span>
            <span className="text-12 text-[#2F4858]">
              {formattedPaymentTime}
            </span>
          </div>
        </div>
        <div className="col-auto">
          <div className="text-14 text-[#2F4858] text-end mb-1">Total</div>
          <div className="text-16 fw-500 text-[#2DC76D]">
            {formatAmount(Number(billdata.orderPrice.sumprice))}
          </div>
        </div>
      </div>
      <div className="my-2">
        {billdata.delivery === 1 && <div className="dl1">ทานที่ร้าน</div>}
        {billdata.delivery === 2 && <div className="dl2">กลับบ้าน</div>}
        {billdata.delivery === 3 && <div className="dl3">เดลิเวอรี่</div>}
      </div>
      <div>
        <div className="">
          <div className="row gx-2 tc-17 fs-12">
            <div className="col-7">รายการ</div>
            <div className="col-2 text-center">จำนวน</div>
            <div className="col-3 text-end">ราคา</div>
          </div>
        </div>
        <hr className="mt-1 mb-0" />

        <div
          className="bx-main-order-list"
          style={{
            height: isVoided ? "calc(100vh - 520px)" : "calc(100vh - 440px)",
          }}
        >
          <ul className="p-0 m-0 w-100">
            {billdata.product &&
              billdata.product.map((item) => (
                <li className="px-2" key={item.id} style={noPointerStyle}>
                  <div className="row gx-2 align-items-center">
                    <div className="col-7 d-flex align-items-center text-black">
                      <img
                        src={item.productImage}
                        className="foodimg"
                        alt={item.productName}
                      />
                      <div
                        className="fs-12"
                        style={item.productStatus === 4 ? redStrikethrough : {}}
                      >
                        {item.productName}
                      </div>
                    </div>
                    <div className="col-2 fs-14 text-center foodQtyli">
                      {item.productQty}
                    </div>
                    <div className="col-3 fs-14 text-end">
                      <span
                        className="foodPriceli"
                        style={item.productStatus === 4 ? redStrikethrough : {}}
                      >
                        {formatAmount(item.productSumPrice)}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap bx-Foption m-[1px]">
                    {item.optionstandard &&
                      item.optionstandard.map((option) => (
                        <div className="Foption mt-2" key={option.listID}>
                          {option.itemName}
                        </div>
                      ))}
                    {item.optionproduct &&
                      item.optionproduct.map((option) => (
                        <div className="Foption mt-2" key={option.listID}>
                          {option.itemName}
                        </div>
                      ))}
                  </div>

                  {((item.optionnote && item.optionnote.length > 0) ||
                    item.note) && (
                    <div className="fNote">
                      {item.optionnote &&
                        item.optionnote.map((note, index) => (
                          <span key={note.listID}>
                            {note.itemName}{" "}
                            {index !== item.optionnote.length - 1 ? "," : ""}{" "}
                          </span>
                        ))}
                      {item.note}
                    </div>
                  )}
                </li>
              ))}
          </ul>

          {billdata.taxInvoice && (
            <div className="px-1 py-3">
              <div className="bg-[#FFF8F3] rounded-lg p-2 fs-14">
                <div className="text-[#FF6B00] mb-1">ออกใบกำกับเต็มรูปแบบ</div>
                <div className="text-[#061126]">
                  {billdata.taxInvoice.invoice_number}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {billdata.billReturned && billdata.billReturned.length > 0 && (
        <div className="absolute p-3 bottom-[0%] w-100 left-[0%] -translate-y-20 justify-center">
          <div className="w-full bg-[#FACCCD26] rounded-xl p-2 flex flex-col justify-between">
            <div className="justify-between items-center flex">
              <p className="text-[#FF0000] text-md font-black">คืนสินค้า</p>
            </div>
            <div className="flex justify-between">
              <p className="text-[#0760FC] text-md font-medium">
                {billdata.billReturned[0].childBill?.receipt_no}
              </p>
              <p className="text-[#0760FC] text-md font-medium">
                {formatAmount(
                  billdata.billReturned[0].childBill?.total_price || "0"
                )}
              </p>
            </div>
          </div>
        </div>
      )}

      {isVoided && (
        <div className="mt-[-10px]">
          <div
            style={{
              borderRadius: "16px",
              background: "rgba(255, 0, 0, 0.06)",
              padding: "12px 14px",
              marginBottom: "16px",
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-1">
              <div
                style={{
                  color: "#FF0000",
                  fontWeight: 800,
                  fontSize: 16,
                }}
              >
                VOID
              </div>

              <div
                className="d-flex align-items-center text-12"
                style={{ color: "#FF3B30", gap: "16px" }}
              >
                <div>
                  พนักงาน :{" "}
                  <span className="fw-600">
                    {billdata?.userBusinessGroup?.first_name &&
                    billdata?.userBusinessGroup?.last_name
                      ? `${billdata.userBusinessGroup.first_name} ${billdata.userBusinessGroup.last_name}`.trim()
                      : billdata?.staff || "-"}
                  </span>
                </div>
                <div>
                  เวลา :{" "}
                  {billdata?.voided_at ? formatTime(billdata.voided_at) : "-"}
                </div>
              </div>
            </div>
            <div className="text-16" style={{ color: "#061126" }}>
              {billdata?.billVoidRemark?.name || "-"}
              {"  "}
              {billdata?.remark || ""}
            </div>
          </div>
        </div>
      )}

      <div className="absolute p-3 bottom-[0%] w-100 left-[0%]">
        <Collapse in={collapseShow}>
          <div id="collapse1">
            <div className="card card-body border-0 bg-[#f2f7fe] px-3 py-2">
              <div className="d-flex fs-14 tc-10 px-1">
                <div className="me-auto">ยอดรวม</div>
                <div id="txsum">{formatAmount(billdata?.total_price || 0)}</div>
              </div>
              <div className="d-flex fs-12 tc-10 px-1">
                <div className="me-auto">ส่วนลดท้ายบิล</div>
                <div>{formatAmount(billdata.discount_amount || 0)}</div>
              </div>
              <div className="d-flex fs-12 tc-10 px-1">
                <div className="me-auto">มูลค่าสินค้าไม่รวมภาษี</div>
                <div id="txdiscount">
                  {formatAmount(billdata.orderPrice.taxable_amount || 0)}
                </div>
              </div>
              <div className="d-flex fs-12 tc-10 px-1">
                <div className="me-auto">ภาษี</div>
                <div id="txtax">{formatAmount(billdata.orderPrice.vat)}</div>
              </div>
            </div>
          </div>
        </Collapse>
        <button
          className={`btn collapse-total ${collapseShow ? "" : "collapsed"}`}
          type="button"
          onClick={() => setCollapseShow(!collapseShow)}
          aria-controls="collapse1"
          aria-expanded={collapseShow}
          style={{ borderRadius: "8px" }}
        >
          <div className="d-flex align-items-center">
            <div className="me-auto">ยอดรวมทั้งหมด</div>
            <div id="txnet">
              {formatAmount(
                billdata.orderPrice?.final_profit_loss_rounded ||
                  billdata.orderPrice?.sumprice ||
                  0
              )}
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default BillDetails;
